import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create projectTeamManagement API
const projectTeamManagementAPI = createApi({
  reducerPath:"ProjectTeamManagement",
  baseQuery:customFetchBase,
  endpoints:(builder)=>({
    // Priority Endpoints

    // Add project team 
    addProjectTeam: builder.mutation({
      query: (data) => ({
          url: `/ProjectTeamManagement/AddProjectTeam`,
          method: 'POST',
          body: transformRequest(data), 
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    //Get All project team list
    getAllProjectTeamList: builder.mutation({
      query: (data) => ({
          url: `/ProjectTeamManagement/GetProjectTeamManagementByProjectIdlist`,
          method: 'POST',
          body: transformRequest(data), 
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    // delete project team
    deleteProjectTeam: builder.mutation({
      query: (data) => ({
          url: `/ProjectTeamManagement/DeleteProjectTeam?id=${data}`,
          method: 'DELETE',
          // body: transformRequest(data)
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    // Query to get all UnAssign User list
    getUnAssginUserList:builder.query({
      query: (projectId) => ({
          url: `ProjectTeamManagement/GetUnAssignedUserListByProjectId?projectId=${Number(projectId)}`,
          method: 'GET',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
     }),

  }),
})

// Extract hooks for easy access to various API requests 
export const {
  useAddProjectTeamMutation,
  useGetAllProjectTeamListMutation,
  useDeleteProjectTeamMutation,
  useLazyGetUnAssginUserListQuery,
} =projectTeamManagementAPI;

export default projectTeamManagementAPI;